import { Children, type ReactNode } from 'react'
import cx from 'classnames'
import styles from './ButtonCollection.module.css'

interface ButtonCollectionProps {
  children?: ReactNode
  centered?: boolean
  fullWidth?: boolean
}

/**
 * Lays out buttons in a spaced row.
 */
export function ButtonCollection({
  children,
  centered,
  fullWidth = false,
}: ButtonCollectionProps) {
  return (
    <div
      className={cx(
        styles.root,
        centered && styles.centered,
        fullWidth && styles.fullWidth,
      )}
    >
      {Children.map(
        children,
        (child) =>
          child && (
            <div className={cx(styles.item, fullWidth && styles.fullWidth)}>
              {child}
            </div>
          ),
      )}
    </div>
  )
}
